import type { TranslationKeys } from './en';
const zhBase: TranslationKeys = {
    // ── 通用 ──
    app_name: 'Seeday',
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    retry: '重试',
    expand: '展开',
    close: '关闭',
    notification_action_confirm: '✓ 确认',
    notification_action_deny: '我在做别的',
    notification_action_view_report: '看日报',
    notification_action_grow_plant: '种植物',
    notification_action_weekend_confirm: '记一下',
    notification_action_weekend_deny: '忽略',
    notification_action_open_chat: '打开聊天',
    notification_action_still_yes: '✓ 还在',
    notification_action_still_no: '我在做别的',
    loading: '加载中…',
    app_loading_wait: '加载中，稍等一下～～',
    no_data: '暂无数据',
    // ── 时间格式 ──
    duration_hours_minutes: '{{hours}}小时{{mins}}分钟',
    duration_minutes: '{{mins}}分钟',
    duration_label: '耗时 {{duration}}',
    elapsed_label: '已持续 {{duration}}',
    // ── Header ──
    header_login: '登录/注册',
    header_confirm_logout: '确定要退出登录吗？',
    // ── 底部导航 ──
    nav_record: '记录',
    nav_report: '日记',
    nav_profile: '我的',
    // ── 聊天 / 记录页面 ──
    chat_title: '记录',
    chat_history_readonly: '已切换到历史日期，切换回今日可继续记录',
    chat_ongoing: '进行中',
    chat_current_activity: '正在进行: ',
    chat_date_section_hint: '今天被看见的时间',
    chat_placeholder_mood: '记录当前心情（如激动）... 点击爱心切换成活动记录',
    chat_placeholder_activity: '记录当前活动 (如: 吃饭)... 点击爱心切换成心情记录',
    chat_placeholder_neutral: '写下这一刻，温室会记住它',
    chat_historical_read_only: '只能查看历史记录，无法在过去的日期输入',
    chat_switch_to_activity: '切换到活动模式',
    chat_switch_to_mood: '切换到心情模式',
    chat_confirm_delete: '确定要删除这条记录吗？',
    chat_edit_record: '编辑记录',
    chat_insert_record: '插入记录',
    chat_label_content: '内容',
    chat_placeholder_content: '做了什么...',
    chat_label_start_time: '开始时间',
    chat_start_time_no_future: '开始时间不能晚于当前时间',
    chat_label_end_time: '结束时间',
    chat_title_edit: '编辑',
    chat_title_insert: '在此后插入',
    chat_title_delete: '删除',
    chat_load_more_records: '加载更多记录…',
    chat_reached_oldest: '— 已是最早的记录 —',
    chat_custom_label_default: '自定义',
    chat_unknown_mood_label: '待识别',
    chat_pick_mood_for_record: '选择这条记录的心情',
    chat_mood_note_label: '心情记录',
    chat_mood_note_placeholder: '写下你做这件事时的心情...',
    chat_adjust_mood_label: '调整心情标签',
    chat_duration_logged: '留下了 {{minutes}}分钟',
    chat_end_activity: '结束',
    chat_convert_to_activity: '改成活动',
    chat_convert_to_mood: '改成心情',
    chat_magic_pen_open: '魔法笔',
    chat_magic_pen_title: '魔法笔',
    chat_magic_pen_subtitle: '补录今天漏记的活动，或从笔记中提取待办',
    chat_magic_pen_confirm: '确认写入',
    chat_magic_pen_mode_on: '魔法笔模式已开启',
    chat_magic_pen_mode_off: '魔法笔模式已关闭',
    chat_magic_pen_retry_failed: '重试失败项',
    chat_magic_pen_cancel: '取消',
    chat_magic_pen_group_activity: '活动补录',
    chat_magic_pen_group_todo: '待办新增',
    chat_magic_pen_group_unparsed: '未识别片段',
    chat_magic_pen_group_auto_written: '已自动写入',
    chat_magic_pen_auto_written_badge: '已自动写入',
    chat_magic_pen_undo_auto_written: '撤销',
    chat_magic_pen_linked_mood_label: '关联心情',
    chat_magic_pen_unparsed_hint: '以下内容无法自动识别，你可以在主输入中手动新增。',
    chat_magic_pen_missing_time: '开始和结束时间不能为空',
    chat_magic_pen_estimated_time: '估算时间，请确认',
    chat_magic_pen_invalid_time: '时间范围无效',
    chat_magic_pen_future_time: '结束时间不能晚于当前时间',
    chat_magic_pen_cross_day: '开始和结束时间必须是同一天',
    chat_magic_pen_overlap: '与其他条目时间重叠',
    chat_magic_pen_overlap_ongoing: '与进行中活动时间冲突',
    chat_magic_pen_overlap_hint: '与"{{activity}}"时间冲突，请调整',
    chat_magic_pen_partial_success: '部分条目写入失败，可修改后重试',
    chat_magic_pen_ai_error: '解析失败，请重试',
    chat_magic_pen_success_summary: '已补录 {{activityCount}} 条活动，新增 {{todoCount}} 条待办',
    chat_magic_pen_item_success: '写入成功',
    chat_magic_pen_item_error: '写入失败',
    chat_magic_pen_upgrade_title: '魔法笔为 Pro 功能',
    chat_magic_pen_upgrade_desc: '开通 Pro 后可使用魔法笔，一键整理输入并提取活动与待办。',
    chat_magic_pen_upgrade_cta: '去开通 Pro',
    chat_magic_pen_upgrade_later: '暂不开通',
    // ── 待办页面 ──
    todo_title: '待办管理',
    todo_filter_daily: '今日',
    todo_filter_weekly: '本周',
    todo_filter_monthly: '本月',
    todo_empty: '暂无待办任务',
    todo_add: '添加待办',
    todo_edit: '编辑待办',
    todo_label_content: '内容',
    todo_placeholder_content: '做什么...',
    todo_label_priority: '优先级',
    todo_label_recurrence: '重复',
    todo_label_category: '分类',
    todo_placeholder_custom_category: '自定义...',
    todo_delete_confirm: '删除此待办',
    todo_delete_recurring_title: '这是一个重复待办',
    todo_delete_recurring_desc: '请选择删除范围',
    todo_delete_today_only: '仅删除今天',
    todo_delete_all_future: '以后都删除',
    todo_duration: '耗时 {{minutes}}分钟',
    todo_pin: '置顶',
    todo_unpin: '取消置顶',
    todo_start: '开始计时',
    todo_in_progress: '进行中',
    // 优先级标签
    priority_urgent_important: '紧急重要',
    priority_important_not_urgent: '重要不紧急',
    priority_urgent_not_important: '紧急不重要',
    priority_not_important_not_urgent: '不重要不紧急',
    // 重复标签
    recurrence_none: '不重复',
    recurrence_daily: '每天',
    recurrence_weekly: '每周',
    recurrence_monthly: '每月',
    // ── 报告页面 ──
    report_title: '日记',
    report_calendar_view: '日历视图',
    report_daily: '日报',
    report_weekly: '周报',
    report_monthly: '月报',
    report_custom: '定制报告',
    report_completed: '已完成',
    report_total_tasks: '总任务',
    report_completion_rate: '完成率',
    report_habit_tracking: '打卡习惯',
    report_checked: '已打卡',
    report_unchecked: '未打卡',
    report_quadrant_distribution: '四象限分布',
    report_completion_trend: '完成趋势',
    report_activity: '活动',
    report_activity_records: '活动记录',
    report_ai_diary_analysis: '日记洞察',
    report_ai_diary_waiting: '{{companion}} 在等你今天的第一条记录。',
    report_generate_diary: '查看今日观察笔记',
    report_generate_confirm: '每天只能生成一次今日陪伴日记，确认现在生成吗？',
    report_generating: '{{companion}} 正在写日记...',
    report_generating_variant_1: '{{companion}} 正在认真整理今天的点滴，为你写下一篇日记……',
    report_generating_variant_2: '{{companion}} 在帮你把今日的回忆变成文字，请给 ta 一点点时间～',
    report_generating_variant_3: '{{companion}} 正在整理今天的心情与节奏...',
    report_generating_variant_4: '{{companion}} 已收到今日记录，正在认真落笔...',
    report_generating_patience: '跨越光年投递手记需要时间，请耐心等待 1-2 分钟',
    report_ai_diary_header: '今日陪伴日记',
    report_coming_soon: '功能开发中',
    report_weekly_coming_soon: '周报功能敬请期待',
    report_monthly_coming_soon: '月报功能敬请期待',
    report_custom_coming_soon: '定制报告功能敬请期待',
    report_completed_tasks: '已完成任务',
    report_all_tasks: '总任务',
    report_no_tasks: '暂无任务',
    report_close_detail: '关闭报告详情',
    report_error_unknown: '未知错误',
    report_activity_category: '活动分类',
    report_view_diary_book: '日记本',
    report_generate_button: '生成日记',
    report_generate_success: '今日日记已生成。',
    report_generate_already: '日记已经生成，去日记本里看看吧~',
    report_early_tip: '日记只可生成一次，可以在 20:00 之后再来看看哦～',
    report_early_tip_ok: '知道了',
    report_back_diary_book: '日记本',
    report_generate_plant: '生成植物',
    report_section_collapse: '收起',
    report_section_expand: '展开',
    report_todo_section: '待办事项',
    report_upgrade_title: '开通会员',
    report_upgrade_desc: '陪伴日记是 Pro 会员专属功能，升级后即可解锁每日陪伴日记生成。',
    report_upgrade_btn: '立即开通 Pro',
    report_upgrade_later: '以后再说',
    report_teaser_unlock: '✨ 解锁今晚的完整故事 →',
    report_swipe_hint: '← 左滑查看陪伴日记 & 手写日记',
    report_my_diary: '我的日记',
    report_diary_placeholder: '写下今天的心情与感受…',
    report_diary_empty: '未留下文字…',
    report_save: '保存',
    report_habit_checkin: '习惯打卡',
    report_goal_progress: '目标进展',
    report_goal_done_today: '今日推进',
    report_goal_not_today: '今日未动',
    report_recurring_tasks: '重复任务',
    report_task_priority: '任务优先级',
    report_root_section_title: '根系观测窗',
    report_root_section_subtitle: '那些被记录的时刻，正在地下悄悄生长。',
    report_root_empty_title: '土壤还在蓄能',
    report_root_empty: '先留下一段5分钟以上的时光，土壤就会开始回应你',
    plant_section_generated_badge: '今日已生成',
    plant_generate_button: '生成植物',
    plant_generating: '根系正在凝结成今日植物...',
    plant_generate_try_after_20: '请在 20:00 后再试',
    plant_generate_done_button: '今日已生成',
    plant_generate_locked_hint: '根系正在生长中，晚上 8 点后可生成植物。',
    plant_generate_locked_with_diary_hint: '根系生长中，20:00后可生成植物和今日日记',
    plant_early_activities: '今天已记录 {{count}} 个活动',
    plant_generate_ready_hint: '根系已准备完成，现在可以生成今日植物。',
    plant_generate_confirm: '确认现在生成今日植物吗？生成后将锁定且不可修改。',
    plant_generate_success: '今日植物已生成。',
    plant_generate_already: '今日植物已生成，请明天再来。',
    plant_generate_empty_day: '今天还没有活动记录，土壤正在等待。',
    plant_generate_empty_day_fallback: '今天还没有可生成植物的活动记录，先记录一段时光，今晚再来看看。',
    plant_generate_monthly_exhausted: '这个根系类型本月的植物都已经生成过了，下个月会重置候选池。',
    plant_generate_failed: '生成失败，请稍后重试。',
    plant_reveal_title: '今日植物揭晓',
    plant_reveal_subtitle: '根系已封存为今日植物，明天会继续从新的记录生长。',
    plant_reveal_special_air: '今天是轻量空气日，植物以更轻盈的姿态记录了你的节奏。',
    plant_reveal_special_entertainment: '今天以娱乐放松为主，植物把这份松弛感收进了枝叶。',
    plant_image_alt: '今日植物图像',
    plant_image_missing: '植物素材加载中，请稍后再试。',
    plant_detail_title: '根段详情',
    plant_detail_activity: '活动',
    plant_detail_time_range: '时间段',
    plant_detail_category: '类别',
    plant_detail_duration: '时长',
    plant_detail_focus: '专注度',
    plant_focus_high: '高专注',
    plant_focus_medium: '中专注',
    plant_direction_left_bottom: '左',
    plant_direction_left_top: '中偏左',
    plant_direction_top: '正中',
    plant_direction_right_top: '中偏右',
    plant_direction_right_bottom: '右',
    plant_canvas_reset: '重置',
    plant_category_work_study: '学习工作',
    plant_category_exercise: '运动',
    eco_sphere_mood_label: '心情',
    eco_sphere_activity_label: '活动',
    eco_sphere_empty_label: '待解锁',
    eco_sphere_diary_label: '日记本',
    eco_sphere_mood_energy_title: '今日心情能量曲线',
    eco_sphere_no_mood_data: '还没有心情记录，去聊聊你的状态吧',
    eco_sphere_no_activity_data: '还没有活动记录',
    eco_sphere_night_hint: '数据将在生成日记后归入今日日记',
    diary_nav_prev: '前一天',
    diary_nav_next: '后一天',
    diary_back_to_shelf: '往回',
    diary_shelf_count: '已收集 {{count}} 个月',
    diary_days_count: '共 {{count}} 天',
    diary_shelf_open_calendar: '选择日期',
    diary_shelf_back_year: '返回年份',
    diary_shelf_no_diary: '当前日期没有日记',
    diary_shelf_open_date: '打开 {{date}}',
    diary_shelf_search_hint: '输入数字找那天的日记，输入文字搜写过的内容～',
    diary_shelf_text_no_results: '未找到相关日记',
    diary_shelf_text_results_count: '找到 {{count}} 篇',
    diary_shelf_field_diary: '日记',
    diary_shelf_field_observation: '观察',
    diary_shelf_field_activity: '活动',
    diary_shelf_field_mood: '情绪',
    diary_cover: '日记本封面',
    diary_cover_subtitle: '陪伴手记',
    diary_back_cover: '日记本封底',
    diary_day_n: '第 {{n}} 天',
    diary_double_tap_open: '双击打开',
    diary_double_tap_zoom: '双击放大',
    diary_star_count: '{{count}} 颗星',
    diary_expanded_ai_observation: 'AI 观察笔记',
    diary_expanded_ai_pending: 'AI 正在整理笔记…',
    diary_expanded_ai_empty: '暂无 AI 笔记',
    diary_expanded_today_after_8: '今日日记将在 20:00 后生成',
    diary_expanded_no_diary: '暂无日记记录',
    diary_expanded_activity: '活动分类',
    diary_expanded_mood: '今日心情',
    diary_expanded_my_diary: '我的日记',
    diary_expanded_no_note: '未留下文字…',
    plant_save_card: '保存卡片',
    plant_tap_to_flip: '轻点翻转',
    plant_card_diary_button: '生成日记',
    // ── 认证页面 ──
    auth_welcome_back: '欢迎回来',
    auth_create_account: '创建账号',
    auth_login_subtitle: '登录以同步您的数据',
    auth_register_subtitle: '注册以开始云端同步',
    auth_account_label: '邮箱地址',
    auth_account_placeholder: '邮箱地址',
    auth_nickname_label: '昵称',
    auth_nickname_placeholder: '你的昵称 (选填)',
    auth_password_label: '密码',
    auth_password_placeholder: '密码',
    auth_login_button: '登录',
    auth_register_button: '注册',
    auth_switch_to_register: '没有账号？点击注册',
    auth_switch_to_login: '已有账号？点击登录',
    auth_register_success: '验证码已发送至您的邮箱，请在下方输入以完成注册。',
    auth_otp_placeholder: '输入 6 位验证码',
    auth_resend_code: '重新发送验证码',
    auth_verify_button: '验证',
    auth_error_rate_limit: '操作过于频繁，请稍后再试（邮件发送受限）',
    auth_error_invalid_credentials: '邮箱或密码错误',
    auth_error_user_exists: '该邮箱已被注册',
    auth_error_password_short: '密码长度至少为6位',
    auth_error_invalid_grant: '登录信息无效或已过期',
    auth_error_invalid_account: '请输入有效的邮箱地址',
    auth_error_generic: '发生错误：',
    auth_select_avatar: '选择头像',
    auth_close: '关闭',
    auth_more: '更多',
    auth_change_avatar: '更换头像',
    avatar_alt: '头像',
    auth_google_signin: '使用 Google 继续',
    auth_apple_signin: '使用 Apple 登录',
    auth_or_divider: '或',
    // ── AI 批注气泡 ──
    annotation_condensing: '凝结中...',
    annotation_condense: '凝结',
    annotation_condensed: '已凝结',
    annotation_hover_pause: '悬停中，暂停消失',
    annotation_suggestion_started: '已开始 ✓',
    // ── 星尘珍藏卡片 ──
    stardust_loading: '正在读取记忆...',
    stardust_error_default: '记忆加载失败，请稍后重试',
    stardust_from: '来自 {{name}} · {{date}}',
    // ── 待办分类 ──
    category_study: '学习',
    category_work: '工作',
    category_social: '社交',
    category_life: '生活',
    category_entertainment: '娱乐',
    category_health: '健康',
    // ── 心情标签 ──
    mood_happy: '开心',
    mood_calm: '平静',
    mood_focused: '专注',
    mood_satisfied: '满足',
    mood_tired: '疲惫',
    mood_anxious: '焦虑',
    mood_bored: '无聊',
    mood_down: '低落',
    // ── 语言切换 ──
    language_switch: '语言',
    language_en: 'EN',
    language_zh: '中',
    weekday_short_sun: '日',
    weekday_short_mon: '一',
    weekday_short_tue: '二',
    weekday_short_wed: '三',
    weekday_short_thu: '四',
    weekday_short_fri: '五',
    weekday_short_sat: '六',
    // ── 成长页面 ──
    nav_growth: '成长',
    growth_title: '成长',
    growth_daily_goal_title: '我的人生主线目标',
    growth_daily_goal_subtitle: '每天写下目标能将实现目标的可能性提高10倍',
    growth_daily_goal_placeholder: '写下你当前最重要的目标...',
    growth_daily_goal_confirm: '确认',
    growth_daily_goal_disable: '不再出现',
    growth_daily_goal_enable: '每日目标提醒弹窗',
    growth_life_goal_title: '人生目标管理',
    growth_life_goal_desc: '和我的画像双向同步，用来提醒你长期方向。',
    growth_life_goal_placeholder: '写下你想长期坚持的方向...',
    growth_life_goal_sync_hint: '与“我的画像 > 人生目标”实时同步',
    growth_life_goal_save: '保存',
    growth_life_goal_saving: '保存中...',
    growth_life_goal_saved: '已同步到我的画像',
    growth_life_goal_save_failed: '同步失败，请重试',
    growth_life_goal_no_changes: '没有需要保存的修改',
    growth_bottle_section: '习惯 / 目标',
    growth_bottle_section_hint: '为你的植物制作一瓶营养液',
    growth_add_bottle: '添加瓶子',
    growth_add_bottle_modal_title: '积累一瓶新的营养液',
    growth_bottle_name: '名称',
    growth_bottle_name_placeholder: '例如：每天阅读30分钟',
    growth_bottle_type: '类型',
    growth_bottle_type_habit: '习惯',
    growth_bottle_type_goal: '目标',
    growth_bottle_max_reached: '最多只能添加10个瓶子',
    growth_bottle_achieved: '已达成',
    growth_bottle_irrigate_hint: '可以制作成营养液浇灌植物',
    growth_bottle_irrigate: '浇灌植物',
    growth_bottle_irrigated: '已浇灌植物',
    growth_bottle_goal_confirm: '是否已达成目标？',
    growth_bottle_goal_yes: '是',
    growth_bottle_goal_no: '继续追踪',
    growth_bottle_round: '第{{round}}轮',
    growth_bottle_stars: '{{stars}}/21',
    growth_todo_section: '近日要事',
    growth_todo_add: '添加待办',
    growth_todo_title_placeholder: '待办标题...',
    growth_todo_due_date: '截止时间',
    growth_todo_priority: '紧急程度',
    growth_todo_priority_high: '高',
    growth_todo_priority_medium: '中',
    growth_todo_priority_low: '低',
    growth_todo_link_bottle: '关联瓶子',
    growth_todo_none: '无',
    growth_todo_empty: '暂无待办事项',
    growth_todo_title_required: '请输入待办标题',
    growth_todo_complete: '完成待办',
    growth_focus_title: '专注模式',
    growth_focus_start: '开始',
    growth_focus_end: '结束',
    growth_focus_end_confirm: '确定要结束专注吗？',
    growth_focus_summary: '本次专注时长：{{duration}}',
    growth_focus_set_duration: '设置时长',
    growth_focus_counting_up: '正计时',
    growth_focus_resting: '休息一下',
    growth_focus_skip_rest: '跳过休息',
    todo_decompose_btn: '分步完成',
    todo_decompose_regenerate_btn: '重新拆解',
    todo_decompose_loading: '正在拆解...',
    todo_decompose_error: '拆解失败，请重试',
    todo_decompose_empty: '没拆出步骤，换个说法试试',
    todo_decompose_steps_label: '子步骤',
    todo_decompose_min: '分钟',
    todo_sequential_focus: '连续专注',
    growth_habit_todo_prompt: '自动生成每日待办？',
    growth_habit_todo_confirm: '将「{{name}}」添加为每日重复待办？',
    growth_habit_todo_dismiss: '跳过',
    growth_bottle_create_todo: '生成待办',
    growth_todo_recurrence: '重复',
    growth_todo_recurrence_once: '仅一次',
    growth_todo_recurrence_daily: '每天',
    growth_todo_recurrence_weekly: '每周',
    growth_todo_due_datetime: '截止时间',
    growth_todo_start: '开始',
    growth_todo_weekly_days: '选择星期',
    growth_todo_quick_add_placeholder: '添加待办，回车保存...',
    todo_due_badge_today: '今日',
    todo_due_badge_tomorrow: '明天',
    todo_due_badge_overdue: '已逾期',
    todo_sort_smart: '智能排序',
    todo_sort_manual: '手动顺序',
    growth_bottle_name_duplicate: '同名瓶子已存在',
    growth_bottle_todo_prompt: '为「{{name}}」生成待办？',
    growth_bottle_open_detail: '打开「{{name}}」详情',
    growth_bottle_stats_last7: '近7天打卡',
    growth_bottle_stats_streak_current: '当前连续',
    growth_bottle_stats_streak_best: '最长连续',
    growth_bottle_delete: '删除瓶子',
    growth_bottle_delete_confirm: '确认删除「{{name}}」吗？',
    growth_bottle_sync_pending: '同步中',
    growth_bottle_sync_failed: '同步失败',
    // ── 我的页面 ──
    profile_title: '个人中心',
    profile_streak: '回到温室',
    profile_weekly_login_hint: '本周回来 {{days}} 天',
    profile_today_activities: '沉淀时光',
    profile_today_activities_hint: '今天 {{count}} 个时刻',
    profile_completed_goals: '成长目标',
    profile_completed_goals_hint: '坚持正在结果',
    profile_ai_mode: 'AI 陪伴模式',
    profile_ai_mode_desc: '开启后，AI 会根据你的记录进行陪伴提醒',
    profile_ai_companion_select: '选择陪伴伙伴',
    profile_ai_mode_van_subtitle: '情绪治愈',
    profile_ai_mode_agnes_subtitle: '引领指导',
    profile_ai_mode_zep_subtitle: '生活真实',
    profile_ai_mode_momo_subtitle: '从容温吞',
    profile_free: '免费',
    profile_annotation_drop: '陪伴频率',
    profile_drop_low: '安静',
    profile_drop_medium: '适中',
    profile_drop_high: '常伴',
    profile_daily_goal: '每日人生主线目标',
    profile_daily_goal_desc: '每次进入成长页面时显示目标填写弹窗',
    profile_long_term_profile: '开启专属记忆',
    profile_long_term_profile_desc: '开启后，AI 会记住你们之间的点滴，陪伴会越来越懂你。',
    profile_long_term_profile_saved: '专属记忆设置已更新',
    profile_long_term_profile_save_failed: '专属记忆设置失败，请重试',
    profile_routine_title: '我的作息',
    profile_routine_desc: '设置起床、睡觉和三餐时间，便于日常提醒更贴合你。',
    profile_routine_time_section: '作息时间',
    profile_routine_save: '保存',
    profile_routine_saving: '保存中...',
    profile_routine_no_changes: '作息没有变化',
    profile_routine_saved: '作息已保存',
    profile_routine_save_failed: '作息保存失败，请重试',
    profile_ai_memory_locked_title: 'AI 专属记忆（Pro）',
    profile_ai_memory_locked_desc: '升级 Pro 后可开启专属记忆，AI 会持续记住你的偏好与经历。',
    profile_user_profile_title: 'AI 专属记忆',
    profile_user_profile_desc: '仅 Pro 可用。记录偏好与沟通方式，让 AI 陪伴更懂你。',
    profile_user_profile_tab_schedule: '作息时间',
    profile_user_profile_tab_personalization: '个性化画像',
    profile_user_profile_tab_anniversaries: '我的纪念日',
    profile_user_profile_primary_use: '主要用途',
    profile_user_profile_select_placeholder: '请选择',
    profile_user_profile_use_life_record: '记录生活',
    profile_user_profile_use_organize_thoughts: '整理思路',
    profile_user_profile_use_emotion_management: '情绪管理',
    profile_user_profile_use_habit_building: '养成习惯',
    profile_user_profile_wake_time: '起床',
    profile_user_profile_sleep_time: '睡觉',
    profile_user_profile_breakfast: '早餐',
    profile_user_profile_lunch: '午餐',
    profile_user_profile_dinner: '晚餐',
    profile_user_profile_current_goal: '近期目标',
    profile_user_profile_current_goal_placeholder: '你最近最想推进什么？',
    profile_user_profile_life_goal: '人生目标',
    profile_user_profile_life_goal_placeholder: '可选：写一个更长期的目标',
    profile_user_profile_personalization: '个性化画像',
    profile_user_profile_personalization_placeholder: '你可以自由写下喜欢/不喜欢、相处偏好、沟通习惯等，AI 会在后续陪伴中参考。',
    profile_user_profile_anniversaries: '可见纪念日',
    profile_user_profile_my_anniversaries: '我的纪念日',
    profile_user_profile_anniversary_source_user: '我添加的',
    profile_user_profile_anniversary_source_ai: 'AI 识别',
    profile_user_profile_add_anniversary: '新增',
    profile_user_profile_anniversary_empty: '还没有纪念日',
    profile_user_profile_anni_label_placeholder: '给这个日期起个名字',
    profile_user_profile_anni_repeat: '每年重复',
    profile_user_profile_remove_anniversary: '删除纪念日',
    profile_user_profile_anni_limit: '最多可添加 10 个纪念日',
    profile_user_profile_save: '保存专属记忆',
    profile_user_profile_saving: '保存中...',
    profile_user_profile_no_changes: '没有可保存的修改',
    profile_user_profile_partial_anniversary: '纪念日需要同时填写名称和日期',
    profile_user_profile_saved: '已保存专属记忆，我会慢慢更懂你。',
    profile_user_profile_save_failed: '保存失败，请重试',
    profile_snapshot_title: '画像快照',
    profile_snapshot_desc_enabled: '当前已启用长期画像，建议将参考以下内容。',
    profile_snapshot_desc_disabled: '未启用长期画像，以下信息仅用于本地编辑。',
    profile_snapshot_meal_title: '建议参考饭点',
    profile_snapshot_anniversary_title: '临近纪念日',
    profile_snapshot_recall_title: '最近回忆素材',
    profile_snapshot_empty: '暂无',
    profile_membership: '会员计划',
    profile_upgrade: '升级到 Pro · 解锁全部功能',
    profile_upgrade_trial: '免费试用 Pro · 解锁全部功能',
    profile_upgrade_coming: '即将上线',
    upgrade_back: '返回',
    upgrade_title: '升级 Pro',
    upgrade_plan_label: '选择方案',
    upgrade_plan_monthly: '月付',
    upgrade_plan_annual: '年付',
    upgrade_price_monthly: '$7.99 / 月',
    upgrade_price_annual: '$99.99 / 年',
    upgrade_price_monthly_note: '内测价，原价 $9.99',
    upgrade_price_annual_note: '按年订阅更省心',
    upgrade_feature_label: '解锁权益',
    upgrade_payment_source: '当前支付通道：{{source}}',
    upgrade_continue_button: '继续付款 {{price}}',
    upgrade_restore_button: '恢复购买',
    upgrade_processing: '处理中...',
    upgrade_purchase_success: '购买成功，Pro 已生效。',
    upgrade_restore_success: '恢复成功，会员状态已更新。',
    upgrade_error_iap_not_ready: '当前设备尚未接入 IAP 插件，请完成 iOS 原生侧接线后重试。',
    upgrade_error_subscription_failed: '订阅请求失败，请稍后重试。',
    upgrade_error_activate_failed: '订阅激活失败，请检查购买状态后再试。',
    upgrade_error_restore_failed: '恢复购买失败，请稍后再试。',
    upgrade_error_stripe_not_ready: '当前构建未接入 Stripe 支付。',
    upgrade_error_stripe_not_supported: '当前构建下不支持 Stripe 恢复购买。',
    upgrade_error_generic: '操作失败，请稍后重试。',
    membership_purchase_title: '解锁无限成长可能',
    membership_purchase_subtitle: '开启 Pro 体验，数据不再只是数字',
    membership_purchase_plan_monthly_name: '月度会员',
    membership_purchase_trial_name: '免费试用',
    membership_purchase_trial_desc: '7 天免费试用，随时可取消',
    membership_purchase_trial_period: '7天',
    membership_purchase_plan_yearly_name: '年度会员',
    membership_purchase_plan_monthly_desc: '订阅随心，灵活便捷',
    membership_purchase_plan_yearly_desc: '限时优惠，平均 8.33/月',
    membership_purchase_plan_yearly_tag: '省 15%',
    membership_purchase_plan_period_month: '月',
    membership_purchase_plan_period_year: '年',
    membership_purchase_popular_badge: '人气首选',
    membership_purchase_features_title: 'Pro 专属特权',
    membership_purchase_free_label: '普通用户',
    membership_purchase_pro_label: '会员用户',
    membership_purchase_ai_badge: 'AI加持',
    membership_purchase_ai_enhanced_badge: 'AI增强',
    membership_purchase_feat_all_roles_title: '全部 AI 角色',
    membership_purchase_feat_all_roles_desc: '解锁所有性格的 AI 陪伴者',
    membership_purchase_feat_growth_title: '深度成长追踪',
    membership_purchase_feat_growth_desc: '全维度追踪心理与行为成长变化',
    membership_purchase_feat_memory_title: 'AI深度陪伴',
    membership_purchase_feat_memory_desc: '全角色可选、全频率可调、专属记忆',
    membership_purchase_feat_daily_title: '个性化温室日记',
    membership_purchase_feat_daily_desc: '每日生成，记录你的成长与情绪轨迹',
    membership_purchase_feat_weekly_title: '魔法笔一键输入',
    membership_purchase_feat_weekly_desc: '一句话自动提取活动、心情与待办',
    membership_purchase_feat_mood_ai_title: 'AI增强识别',
    membership_purchase_feat_mood_ai_desc: '会员接入 AI，活动心情分类更准确',
    membership_purchase_feat_star_ai_title: 'AI智能关联',
    membership_purchase_feat_star_ai_desc: '会员接入 AI，星星瓶子自动关联更准确',
    membership_purchase_feat_monthly_title: '待办分步完成',
    membership_purchase_feat_monthly_desc: '将大目标拆成可执行的小步骤，推进更轻松',
    membership_purchase_feat_yearly_title: '深度生长追踪：周/月/定制报告（敬请期待）',
    membership_purchase_feat_yearly_desc: '敬请期待，正在持续开发中',
    membership_purchase_compare_all_roles_free: 'Van 角色可用',
    membership_purchase_compare_all_roles_pro: '4 位 AI 角色全部解锁',
    membership_purchase_compare_growth_free: '基础成长观察',
    membership_purchase_compare_growth_pro: '深度成长追踪与趋势洞察',
    membership_purchase_compare_mood_title: '活动心情分类',
    membership_purchase_compare_mood_free: '基础心情分类',
    membership_purchase_compare_mood_pro: 'AI增强识别，分类更细致更贴合',
    membership_purchase_compare_daily_free: '基础日记视图',
    membership_purchase_compare_daily_pro: '生成个性化温室日记，记录更完整',
    membership_purchase_compare_star_bottle_title: '星星瓶子自动关联',
    membership_purchase_compare_star_bottle_free: '按基础规则自动关联',
    membership_purchase_compare_star_bottle_pro: 'AI智能关联，匹配更准确',
    membership_purchase_compare_todo_free: '基础待办记录',
    membership_purchase_compare_todo_pro: '待办分步拆解，推进更轻松',
    membership_purchase_compare_report_free: '每日基础报告',
    membership_purchase_compare_report_pro: '周/月/定制报告（持续开发中）',
    membership_purchase_cta: '立即升级',
    membership_purchase_footer_cancel_anytime: '随时取消订阅',
    membership_purchase_footer_secure_pay: '安全支付',
    profile_help: '帮助与支持',
    profile_privacy: '隐私政策',
    profile_about: '关于应用',
    profile_change_password: '修改密码',
    profile_set_password: '设置登录密码',
    change_password_title_change: '修改密码',
    change_password_title_set: '设置登录密码',
    change_password_hint: '设置密码后，也可以用邮箱 + 密码直接登录',
    change_password_new_placeholder: '新密码（至少6位）',
    change_password_confirm_placeholder: '再次输入新密码',
    change_password_save: '保存',
    change_password_success: '密码已更新',
    change_password_mismatch: '两次密码不一致',
    change_password_too_short: '密码至少需要6位',
    change_password_error: '更新失败，请稍后重试',
    profile_region_settings: '地区设置',
    profile_region_settings_desc: '用于节假日与天气推断。可输入城市/地区，或直接使用当前位置。',
    profile_region_current: '当前地区：{{value}}',
    profile_region_not_set: '未设置',
    profile_region_placeholder: '输入城市或地区，例如 Shanghai / Milan',
    profile_region_use_current: '使用当前位置',
    profile_region_locating: '定位中...',
    profile_region_save: '保存',
    profile_region_saving: '保存中...',
    profile_region_not_found: '未找到该地区，请换个更具体的名称',
    profile_region_country_fallback_hint: '未匹配到具体地区，可改为保存国家：{{value}}',
    profile_region_save_country: '保存国家',
    profile_region_save_error: '地区保存失败，请稍后重试',
    profile_region_locate_error: '定位失败，请检查定位权限后重试',
    profile_root_direction_settings: '根系方向设置',
    profile_root_direction_settings_desc: '设置每个方向对应的类型。调整后仅影响展示方向，不影响判断结果。',
    profile_root_direction_reset: '重置',
    profile_root_direction_save: '保存',
    profile_root_direction_saving: '保存中...',
    profile_root_direction_duplicate_error: '方向类型不能重复，请修改后再保存',
    profile_root_direction_save_error: '保存失败，请稍后重试',
    profile_logout: '退出登录',
    profile_plus_only: '升级 Pro 解锁',
};

import { zhExtra } from './zh.extra';
const zh = { ...zhBase, ...zhExtra };
export default zh;
